// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"72":"Cart","187":"NotFound","578":"Pizza"}[chunkId] + "." + {"72":"d6b65ffb","187":"d6b22fcc","578":"e7f17b15"}[chunkId] + ".chunk.js";
};